import { Link } from 'react-router-dom'
import heroImg from '../assets/GntB5.jpg'
import './Investment.css'

const FOCUS_AREAS = [
  {
    icon: '🏗️',
    title: 'Infrastructure Modernization and Partnerships',
    body: 'We fund and partner on upgrading ports, rail networks, highways, and logistics hubs — transforming outdated infrastructure into efficient, future-ready assets that drive regional competitiveness.',
  },
  {
    icon: '🌍',
    title: 'Regional Trade Enablement Projects',
    body: 'Targeted investments in multimodal corridors, trade facilitation platforms, and cross-border logistics solutions that unlock new markets and accelerate the flow of goods across regions.',
  },
  {
    icon: '⚖️',
    title: 'Governance-First Investment Structures',
    body: 'Every investment is built on transparency, strong governance, and long-term alignment. We prioritize structures that protect capital while maximizing measurable economic and social impact.',
  },
]

const WHY_US = [
  'Long-term value creation over short-term returns',
  'Deep expertise in transport, logistics, and trade infrastructure',
  'Proven ability to blend public-private partnerships with private capital',
  'Full transparency and governance excellence at every stage',
]

function InvestmentPage({ lang }) {
  const isFr = lang === 'fr'

  return (
    <div className="inv-page">

      {/* ── Hero ─────────────────────────────────────────────── */}
      <section className="inv-hero">
        <div className="inv-hero-overlay" />
        <img src={heroImg} alt="Strategic investment" className="inv-hero-bg" />
        <div className="inv-hero-content">
          <span className="inv-hero-eyebrow">
            {isFr ? 'Investissement Stratégique' : 'Strategic Investment'}
          </span>
          <h1 className="inv-hero-title">
            {isFr
              ? 'Nous déployons le capital là où il crée une valeur économique et infrastructurelle durable.'
              : 'We deploy capital where it creates long-term economic and infrastructure value.'}
          </h1>
          <p className="inv-hero-sub">
            {isFr
              ? 'Au cœur de notre mission se trouve un engagement envers la prospérité durable. Nous investissons stratégiquement dans des projets qui renforcent les chaînes d\'approvisionnement et les corridors commerciaux.'
              : 'At the core of our mission is a commitment to building lasting prosperity. We strategically invest in projects that strengthen supply chains, enhance trade corridors, and deliver sustainable economic growth for generations to come.'}
          </p>
          <div className="inv-hero-actions">
            <Link to="/contact" className="inv-btn primary">
              {isFr ? 'Explorer les partenariats' : 'Explore Partnerships'}
            </Link>
            <Link to="/contact" className="inv-btn outline">
              {isFr ? 'Contacter notre équipe' : 'Contact Our Team'}
            </Link>
          </div>
        </div>
      </section>

      {/* ── Focus areas ──────────────────────────────────────── */}
      <section className="inv-focus">
        <div className="inv-focus-inner">
          <div className="inv-focus-header">
            <h2>{isFr ? 'Nos Domaines d\'Investissement Stratégique' : 'Our Strategic Investment Focus Areas'}</h2>
            <p>{isFr ? 'Trois piliers qui guident chaque décision d\'investissement.' : 'Three pillars that guide every investment decision.'}</p>
          </div>
          <div className="inv-focus-grid">
            {FOCUS_AREAS.map((area, i) => (
              <div key={i} className="inv-focus-card">
                <div className="inv-focus-icon">{area.icon}</div>
                <h3 className="inv-focus-title">{area.title}</h3>
                <p className="inv-focus-body">{area.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Why us + image strip ─────────────────────────────── */}
      <section className="inv-why">
        <div className="inv-why-inner">
          <div className="inv-why-text">
            <h2>{isFr ? 'Pourquoi nous choisir ?' : 'Why Partner With Us?'}</h2>
            <ul className="inv-why-list">
              {WHY_US.map((item, i) => (
                <li key={i} className="inv-why-item">
                  <span className="inv-why-check">✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <div className="inv-why-quote">
              <p>
                {isFr
                  ? 'Nous ne finançons pas simplement des projets — nous construisons les fondations d\'économies plus solides et de chaînes d\'approvisionnement plus résilientes.'
                  : 'We don\'t just finance projects — we build the foundations for stronger economies and more resilient supply chains.'}
              </p>
            </div>
          </div>
          <div className="inv-why-img-wrap">
            <img src={heroImg} alt="Investment and infrastructure" className="inv-why-img" />
            <div className="inv-why-badge">
              <span className="inv-why-badge-num">10+</span>
              <span className="inv-why-badge-label">{isFr ? 'Ans d\'expertise' : 'Years of expertise'}</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA banner ───────────────────────────────────────── */}
      <section className="inv-cta">
        <div className="inv-cta-inner">
          <h2>
            {isFr
              ? 'Prêt à construire ensemble une valeur infrastructurelle durable ?'
              : 'Ready to build lasting infrastructure value together?'}
          </h2>
          <p>
            {isFr
              ? 'Contactez notre équipe d\'investissement dès aujourd\'hui pour explorer les opportunités de partenariat.'
              : 'Contact our investment team today to explore partnership opportunities.'}
          </p>
          <div className="inv-hero-actions" style={{ justifyContent: 'center' }}>
            <Link to="/contact" className="inv-btn primary">
              {isFr ? 'Contactez-nous' : 'Contact Our Investment Team'}
            </Link>
          </div>
        </div>
      </section>

    </div>
  )
}

export default InvestmentPage
